import { useChangeLocale } from '../../../../../modules/apis/common/user'
import {
  getLangSetting,
  LOCALE_EN,
  LOCALE_JA,
  LOCALE_KO,
  LOCALE_ZH_CHS,
  LOCALE_ZH_CHT,
  LocaleType,
} from '../../../../../modules/i18n/config'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import useLandingNav from '../useLandingNav'
import MainNavDropdown from './MainNavDropdown'

const languages = [
  { name: '한국어', locale: LOCALE_KO },
  { name: 'English', locale: LOCALE_EN },
  { name: '中文（简体）', locale: LOCALE_ZH_CHS },
  { name: '中文（繁體）', locale: LOCALE_ZH_CHT },
  { name: '日本語', locale: LOCALE_JA },
]

interface LanguageSelectorProps {
  onFinish?: () => void
}

const LanguageSelector = ({ onFinish }: LanguageSelectorProps) => {
  const { locale, updateLandingLocale } = useTranslation()
  const { mutate } = useChangeLocale()
  const { currentUser } = useLandingNav()
  const currentLanguage = getLangSetting(locale)

  const handleLanguageClick = (locale: LocaleType, localeStr: string) => {
    if (currentUser) {
      mutate({ locale })
    } else {
      updateLandingLocale(locale)
    }

    typeof onFinish === 'function' && onFinish()
  }

  return (
    <MainNavDropdown navTitle="언어 변경" subTitle={currentLanguage}>
      {(onClose) => (
        <ul className="sm:p-8 pt-12 flex flex-col gap-y-4">
          {languages.map((language, index) => (
            <li key={index} className="w-full hover:bg-purple-50 active:opacity-50 rounded group">
              <button className="p-10 w-full flex" onClick={() => handleLanguageClick(language.locale, language.name)}>
                <span
                  className={`Body2-14Md sm:Caption-12Md sm:text-black group-hover:text-purple-600 text-left ${
                    language.name === currentLanguage ? 'text-purple-500' : 'text-gray-600'
                  }`}
                >
                  {language.name}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </MainNavDropdown>
  )
}

export default LanguageSelector
